import React from "react";
import { getTreatmentValue } from "../../redux/selectors/splitio";
import { TIMETRACKING_LEGACY_VIEW_SPLIT_NAME } from "../../../shared/constants";
import { NavLink } from "./NavLink";
import { webV1Url } from "../../api/bluecrew/constants";
import { useAppSelector } from "../../redux";

export const TimesheetsNavItem = () => {
  const showTimesheetsInAngular = useAppSelector((state) =>
    getTreatmentValue(state, TIMETRACKING_LEGACY_VIEW_SPLIT_NAME),
  );

  return (
    <li>
      {showTimesheetsInAngular === "on" ? (
        <a href={`${webV1Url}/app.html#!/payroll/company`}>Timesheets</a>
      ) : (
        <NavLink to="/payroll">Timesheets</NavLink>
      )}
    </li>
  );
};
